export const ACCORDION_BUTTON_DISPLAY_NAME = 'AccordionButton'
export const ACCORDION_DISPLAY_NAME = 'Accordion'
export const ACCORDION_DETAILS_DISPLAY_NAME = 'AccordionDetails'
